/* Giftaty v10.37 · customer reviews (snippets/gt-reviews.liquid) on the Giftaty Ops public reviews API.
   - Reads approved reviews (GET) and renders the summary, the breakdown and the list, with sort / photo filter and
     "show more" paging. Results are cached for 5 minutes per page in sessionStorage.
   - Sends new reviews (POST). The API always stores them as pending; the reviewer sees a "awaiting approval" card in
     their own browser until it is published.
   - SEO: on product pages the Product JSON-LD gets aggregateRating + the latest reviews once real data is loaded,
     and the rating row under the title (#pp-reviews-number) shows the live average. */
(function () {
  'use strict';
  if (window.GiftatyReviews) return;
  window.GiftatyReviews = { version: '10.37' };
  var CACHE_TTL = 5 * 60 * 1000;

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function el(tag, cls, text) { var x = document.createElement(tag); if (cls) x.className = cls; if (text != null) x.textContent = text; return x; }
  function fmt(s, vars) { return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return vars[k] == null ? '' : vars[k]; }); }
  function num(v, d) { var n = Number(v); return isFinite(n) ? n : d; }
  function store(get, key, val) {
    try { if (get) return JSON.parse(sessionStorage.getItem(key) || 'null'); sessionStorage.setItem(key, JSON.stringify(val)); } catch (e) { return null; }
  }
  function local(get, key, val) {
    try { if (get) return JSON.parse(localStorage.getItem(key) || 'null'); if (val === null) localStorage.removeItem(key); else localStorage.setItem(key, JSON.stringify(val)); } catch (e) { return null; }
  }
  function dateText(iso, lang) {
    var d = iso ? new Date(iso) : null;
    if (!d || isNaN(d.getTime())) return { text: '', iso: '' };
    var day = ('0' + d.getDate()).slice(-2), mon = ('0' + (d.getMonth() + 1)).slice(-2);
    return { text: day + '/' + mon + '/' + d.getFullYear(), iso: d.toISOString().slice(0, 10) };
  }
  function safeUrl(u) {
    u = String(u || '').trim();
    return /^https?:\/\/[^\s"'<>]+$/i.test(u) ? u : '';
  }
  function plural(count, lang, one, many) { return count === 1 ? one : many; }

  function Reviews(root) {
    var self = this;
    this.root = root;
    try { this.cfg = JSON.parse($(root, '[data-gt-rv-config]').textContent); } catch (e) { return; }
    this.t = this.cfg.t || {};
    this.lang = this.cfg.lang || 'en';
    this.page = 1; this.pages = 1; this.total = 0;
    this.sort = 'newest'; this.photos = false;
    this.list = $(root, '[data-gt-rv-list]');
    this.status = $(root, '[data-gt-rv-status]');
    this.moreWrap = $(root, '[data-gt-rv-more-wrap]');
    this.more = $(root, '[data-gt-rv-more]');
    this.tools = $(root, '[data-gt-rv-tools]');
    this.starTpl = $(root, 'template[data-gt-rv-stars]');
    var sortSel = $(root, '[data-gt-rv-sort]'), photoChk = $(root, '[data-gt-rv-photos]');
    if (sortSel) sortSel.addEventListener('change', function () { self.sort = sortSel.value; self.reload(); });
    if (photoChk) photoChk.addEventListener('change', function () { self.photos = !!photoChk.checked; self.reload(); });
    if (this.more) this.more.addEventListener('click', function () { self.load(self.page + 1, true); });
    this.bindForm();
    this.load(1, false);
  }

  Reviews.prototype.url = function (page) {
    var c = this.cfg, q = ['page=' + page, 'limit=' + (c.limit || 10), 'sort=' + encodeURIComponent(this.sort)];
    if (c.productHandle) q.push('productHandle=' + encodeURIComponent(c.productHandle));
    if (this.photos) q.push('withImages=true');
    return c.api + '?' + q.join('&');
  };
  Reviews.prototype.fetchPage = function (page) {
    var u = this.url(page), key = 'gtrv:' + u, cached = store(true, key);
    if (cached && cached.at && Date.now() - cached.at < CACHE_TTL && cached.data) return Promise.resolve(cached.data);
    return fetch(u, { mode: 'cors', headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    }).then(function (data) {
      if (!data || data.ok === false || !Array.isArray(data.reviews)) throw new Error('bad');
      store(false, key, { at: Date.now(), data: data });
      return data;
    });
  };
  Reviews.prototype.reload = function () { this.page = 1; this.load(1, false); };
  Reviews.prototype.setStatus = function (html, kind) {
    var s = this.status; if (!s) return;
    s.innerHTML = ''; s.hidden = !html;
    if (!html) return;
    if (kind === 'skeleton') { s.appendChild(el('span', 'gt-rv__skeleton')); s.appendChild(el('span', 'gt-rv__skeleton')); return; }
    var p = el('p', kind === 'error' ? 'gt-rv__err' : 'gt-rv__empty', html);
    s.appendChild(p);
    if (kind === 'error') {
      var b = el('button', 'gt-btn gt-btn--secondary gt-btn--sm', this.t.retry || 'Try again'); b.type = 'button';
      var self = this; b.addEventListener('click', function () { self.reload(); });
      s.appendChild(b);
    }
  };
  Reviews.prototype.load = function (page, append) {
    var self = this;
    if (!append) { this.list.hidden = true; this.list.innerHTML = ''; this.setStatus('x', 'skeleton'); this.moreWrap.hidden = true; }
    if (this.more) { this.more.disabled = true; this.more.setAttribute('aria-busy', 'true'); }
    this.fetchPage(page).then(function (data) {
      self.page = page;
      var pg = data.pagination || {};
      self.pages = num(pg.pages, 1); self.total = num(pg.total, data.reviews.length);
      if (!append) {
        self.renderSummary(data.summary, self.total);
        self.setStatus('');
        self.list.innerHTML = '';
        self.renderPending();
      }
      data.reviews.forEach(function (r) { self.list.appendChild(self.card(r)); });
      var any = self.list.children.length > 0;
      self.list.hidden = !any;
      if (!any) self.setStatus(self.t.empty || 'No reviews yet.', 'empty');
      self.moreWrap.hidden = !(self.page < self.pages);
      if (self.tools) self.tools.hidden = !(self.total > 0 || self.photos || self.sort !== 'newest');
      if (self.more) { self.more.disabled = false; self.more.removeAttribute('aria-busy'); }
      if (!append && self.cfg.mode === 'product' && !self.photos && self.sort === 'newest') self.seo(data.summary, data.reviews);
    }).catch(function () {
      if (self.more) { self.more.disabled = false; self.more.removeAttribute('aria-busy'); }
      if (!append) { self.list.hidden = true; self.setStatus(self.t.loadError || 'Could not load the reviews.', 'error'); self.renderPending(); }
    });
  };
  Reviews.prototype.stars = function (rating, size) {
    var s = this.starTpl ? this.starTpl.content.firstElementChild.cloneNode(true) : el('span', 'gt-stars');
    var r = Math.max(0, Math.min(5, num(rating, 0)));
    s.style.setProperty('--gt-stars-pct', (r / 5 * 100).toFixed(1) + '%');
    if (size) s.style.setProperty('--gt-stars-size', size + 'px');
    s.setAttribute('aria-label', fmt(this.t.outOf, { r: Math.round(r * 10) / 10 }));
    return s;
  };
  Reviews.prototype.renderSummary = function (sum, total) {
    var box = $(this.root, '[data-gt-rv-summary]');
    if (!box) return;
    var count = num(sum && sum.count, total), avg = Math.round(num(sum && sum.average, 0) * 10) / 10;
    if (!count) { box.hidden = true; this.updateRatingRow(0, 0); return; }
    box.hidden = false;
    $(box, '[data-gt-rv-avg]').textContent = avg;
    var st = $(box, '[data-gt-rv-avgstars]');
    if (st) { st.style.setProperty('--gt-stars-pct', (avg / 5 * 100).toFixed(1) + '%'); st.setAttribute('aria-label', fmt(this.t.outOf, { r: avg })); }
    $(box, '[data-gt-rv-count]').textContent = fmt(this.t.basedOn, { n: count }).replace('review(s)', plural(count, this.lang, 'review', 'reviews'));
    var dist = (sum && sum.distribution) || {};
    for (var s = 1; s <= 5; s++) {
      var n = num(dist[s], 0), bar = $(box, '[data-gt-rv-bar="' + s + '"]'), bn = $(box, '[data-gt-rv-barn="' + s + '"]');
      if (bar) bar.style.width = Math.round(n * 100 / count) + '%';
      if (bn) bn.textContent = n;
    }
    this.updateRatingRow(avg, count);
  };
  /* the rating row under the product title (snippets/gt-rating-summary.liquid) */
  Reviews.prototype.updateRatingRow = function (avg, count) {
    if (this.cfg.mode !== 'product') return;
    var row = document.getElementById('pp-reviews-number');
    if (!row || !row.classList.contains('gt-rating-sum') || !count) return;
    row.innerHTML = '';
    row.appendChild(this.stars(avg, 18));
    var t = el('span', 'gt-rating-sum__t'); var b = el('b', null, String(avg)); t.appendChild(b);
    t.appendChild(document.createTextNode(' · ' + count + ' ' + (this.lang === 'ar' ? 'تقييم' : plural(count, this.lang, 'review', 'reviews'))));
    row.appendChild(t);
  };
  Reviews.prototype.card = function (r, mine) {
    var li = el('li', 'gt-rv__card' + (mine ? ' gt-rv__card--mine' : '')), lang = this.lang;
    var top = el('div', 'gt-rv__card-top');
    top.appendChild(this.stars(r.rating, 16));
    if (mine) top.appendChild(el('span', 'gt-rv__mine', this.t.pending || 'Your review (awaiting approval)'));
    li.appendChild(top);
    if (r.title) { var h = el('h3', 'gt-rv__card-title', String(r.title)); h.dir = 'auto'; li.appendChild(h); }
    var body = el('p', 'gt-rv__body'); body.dir = 'auto';
    String(r.body || '').split(/\r?\n/).forEach(function (line, i) { if (i) body.appendChild(el('br')); body.appendChild(document.createTextNode(line)); });
    li.appendChild(body);
    var img = safeUrl(r.imageUrl);
    if (img) {
      var a = el('a', 'gt-rv__photo-link'); a.href = img; a.target = '_blank'; a.rel = 'noopener';
      var im = el('img', 'gt-rv__photo'); im.src = img; im.loading = 'lazy'; im.decoding = 'async'; im.width = 240; im.height = 240;
      im.alt = fmt(this.t.photoAlt, { n: r.name || '' });
      a.appendChild(im); li.appendChild(a);
    }
    var by = el('p', 'gt-rv__by');
    var au = el('bdi', 'gt-rv__author', String(r.name || '')); by.appendChild(au);
    if (r.city) by.appendChild(el('span', 'gt-rv__city', ' · ' + r.city));
    var d = dateText(r.createdAt, lang);
    if (d.text) { var tm = el('time', 'gt-rv__date', d.text); tm.setAttribute('datetime', d.iso); by.appendChild(tm); }
    li.appendChild(by);
    if (this.cfg.mode === 'home' && r.productHandle) {
      var pl = el('a', 'gt-rv__product', r.productTitle || this.t.viewProduct || 'View this gift');
      pl.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'products/' + encodeURIComponent(r.productHandle);
      li.appendChild(pl);
    }
    return li;
  };
  /* the reviewer's own pending review, only in their browser, for 7 days or until it is published */
  Reviews.prototype.pendingKey = function () { return 'gtrv-pending:' + (this.cfg.productHandle || 'store'); };
  Reviews.prototype.renderPending = function () {
    var mine = local(true, this.pendingKey());
    if (!mine || !mine.body) return;
    if (Date.now() - (mine.at || 0) > 7 * 864e5) { local(false, this.pendingKey(), null); return; }
    var needle = String(mine.body).replace(/\s+/g, ' ').slice(0, 40), published = $$(this.list, '.gt-rv__body').some(function (b) { return b.textContent.replace(/\s+/g, ' ').indexOf(needle) >= 0; });
    if (published) { local(false, this.pendingKey(), null); return; }
    this.list.insertBefore(this.card(mine, true), this.list.firstChild);
    this.list.hidden = false;
    this.setStatus('');
  };
  /* Product JSON-LD: real aggregateRating + the latest reviews */
  Reviews.prototype.seo = function (sum, reviews) {
    var count = num(sum && sum.count, 0), avg = Math.round(num(sum && sum.average, 0) * 10) / 10;
    if (!count) return;
    var scripts = $$(document, 'script[type="application/ld+json"]'), target = null, data = null, node = null;
    scripts.some(function (s) {
      try {
        var j = JSON.parse(s.textContent);
        var cands = Array.isArray(j) ? j : (j && j['@graph'] ? j['@graph'] : [j]);
        var p = cands.filter(function (x) { return x && (x['@type'] === 'Product' || (Array.isArray(x['@type']) && x['@type'].indexOf('Product') >= 0)); })[0];
        if (p) { target = s; data = j; node = p; return true; }
      } catch (e) {}
      return false;
    });
    var agg = { '@type': 'AggregateRating', ratingValue: avg, reviewCount: count, bestRating: 5, worstRating: 1 };
    var revs = reviews.slice(0, 5).map(function (r) {
      var o = { '@type': 'Review', reviewRating: { '@type': 'Rating', ratingValue: num(r.rating, 5), bestRating: 5, worstRating: 1 }, author: { '@type': 'Person', name: String(r.name || '') }, reviewBody: String(r.body || '').replace(/\s+/g, ' ').slice(0, 500) };
      var d = dateText(r.createdAt); if (d.iso) o.datePublished = d.iso;
      if (r.title) o.name = String(r.title);
      return o;
    });
    if (node) {
      node.aggregateRating = agg; node.review = revs;
      target.textContent = JSON.stringify(data);
    } else if (this.cfg.productTitle) {
      var s = document.createElement('script'); s.type = 'application/ld+json';
      s.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'Product', name: this.cfg.productTitle, url: location.origin + location.pathname, aggregateRating: agg, review: revs });
      document.head.appendChild(s);
    }
  };
  /* ---- write a review ---- */
  Reviews.prototype.bindForm = function () {
    var self = this, form = $(this.root, '[data-gt-rv-form]');
    if (!form) return;
    var body = $(form, '[name="body"]'), counter = $(form, '[data-gt-rv-counter]');
    if (body && counter) body.addEventListener('input', function () { counter.textContent = body.value.length + ' / 600'; });
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      self.submit(form);
    });
  };
  Reviews.prototype.showErr = function (form, msg) {
    var e = $(form, '[data-gt-rv-err]'), t = $(form, '[data-gt-rv-err-text]');
    if (!e) return; t.textContent = msg; e.hidden = false; e.focus && e.setAttribute('tabindex', '-1'); try { e.focus(); } catch (x) {}
  };
  Reviews.prototype.submit = function (form) {
    var self = this, t = this.t, c = this.cfg, err = $(form, '[data-gt-rv-err]'), btn = $(form, '[data-gt-rv-submit]');
    if (err) err.hidden = true;
    var rating = $(form, '[name="rating"]:checked');
    if (!rating) return this.showErr(form, t.needRating || 'Please choose a rating.');
    var bad = $$(form, '[required]').filter(function (f) { return f.type !== 'radio' && !f.checkValidity(); });
    $$(form, '.gt-field').forEach(function (f) { f.classList.remove('is-error'); });
    if (bad.length) { bad.forEach(function (f) { var w = f.closest('.gt-field'); if (w) w.classList.add('is-error'); }); try { bad[0].focus(); } catch (x) {} return; }
    var trap = $(form, '[name="website"]');
    var val = function (n) { var f = $(form, '[name="' + n + '"]'); return f ? String(f.value || '').trim() : ''; };
    var payload = { rating: num(rating.value, 5), name: val('name').slice(0, 40), email: val('email'), body: val('body').slice(0, 600) };
    if (val('city')) payload.city = val('city').slice(0, 30);
    if (val('title')) payload.title = val('title').slice(0, 60);
    if (val('orderNumber')) payload.orderNumber = val('orderNumber').slice(0, 20);
    var opt = $(form, '[name="marketingOptIn"]'); payload.marketingOptIn = !!(opt && opt.checked);
    if (c.productHandle) { payload.productHandle = c.productHandle; payload.productId = String(c.productId); payload.productTitle = c.productTitle; }
    var done = function (ok) {
      if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-label') || btn.textContent; btn.removeAttribute('aria-busy'); }
      if (!ok) return;
      var sent = $(form, '[data-gt-rv-sent]'), fields = $(form, '[data-gt-rv-fields]');
      if (fields) fields.hidden = true;
      if (sent) { sent.hidden = false; try { sent.focus(); } catch (x) {} }
      local(false, self.pendingKey(), { rating: payload.rating, name: payload.name, city: payload.city || '', title: payload.title || '', body: payload.body, createdAt: new Date().toISOString(), at: Date.now() });
      if (self.list) { $$(self.list, '.gt-rv__card--mine').forEach(function (n) { n.remove(); }); self.renderPending(); }
    };
    if (btn) { btn.setAttribute('data-label', btn.textContent); btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = t.sending || 'Sending…'; }
    if (trap && trap.value) { setTimeout(function () { done(true); }, 600); return; } /* a bot filled the trap: pretend, send nothing */
    fetch(c.api, { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) }).then(function (r) {
      return r.text().then(function (txt) { var j = null; try { j = JSON.parse(txt); } catch (e) {} return { status: r.status, ok: r.ok, json: j }; });
    }).then(function (res) {
      if (res.ok && !(res.json && res.json.ok === false)) return done(true);
      var msg = t.failed;
      if (res.status === 429) msg = t.tooMany;
      else if (res.status === 409) msg = t.duplicate;
      else if (res.json && (res.json.error || res.json.message)) {
        var m = String(res.json.error || res.json.message);
        if (/duplicate|already/i.test(m)) msg = t.duplicate; else if (/rate|too many|limit/i.test(m)) msg = t.tooMany;
      }
      done(false); self.showErr(form, msg);
    }).catch(function () { done(false); self.showErr(form, t.failed); });
  };

  function init() { $$(document, '[data-gt-reviews]').forEach(function (r) { if (!r._gtrv) r._gtrv = new Reviews(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
